import { render } from "./ReturnPortalSummary.vue?vue&type=template&id=25a1267c"
import script from "./ReturnPortalSummary.vue?vue&type=script&lang=js"
export * from "./ReturnPortalSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__